import styles from '../../../sass/apricot.module.scss';
export default (function (_ref) {
  var title = _ref.title,
      body = _ref.body,
      _ref$panelClass = _ref.panelClass,
      panelClass = _ref$panelClass === void 0 ? '' : _ref$panelClass;
  return /*#__PURE__*/React.createElement("div", {
    className: "panel ".concat(panelClass, " ").concat(styles.panel)
  }, title ? /*#__PURE__*/React.createElement("div", {
    className: "panel-heading"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "panel-title"
  }, title)) : null, /*#__PURE__*/React.createElement("div", {
    className: "panel-body"
  }, body));
});